module.exports = __webpack_public_path__ + "img/CM.90e5fbe0.svg";